import { useState } from 'react';

const Tutorials = () => {
    const [selectedVideo, setSelectedVideo] = useState(null);

    const videos = [
        {
          id: 0,
          title: "Quick Overview of the Slipstream Dashboard",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/c1a3dbd786e14f0f942094ea64425bb1-c2b0c43b57b4ed40-full-play.gif", // Replace with actual Loom thumbnail URL
          url: "https://www.loom.com/embed/c1a3dbd786e14f0f942094ea64425bb1?sid=a8bf70f7-97b5-406d-a5fc-bfb8cdfa47a3", // Replace with actual Loom URL
        },
        {
          id: 1,
          title: "Understanding Important Settings in QuickBooks",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/6238badee1fd4015b64fb55410677108-46f821388b7a4974-full-play.gif", // Replace with actual Loom thumbnail URL
          url: "https://www.loom.com/embed/6238badee1fd4015b64fb55410677108?sid=7d866a93-8419-40eb-a45c-353ee3b7dc46", // Replace with actual Loom URL
        },
        {
          id: 2,
          title: "Mastering the QuickBooks Search Bar",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/010397793f164fae98c1f7ec58cf6db5-5dad1a7e555d2421-full-play.gif",
          url: "https://www.loom.com/embed/010397793f164fae98c1f7ec58cf6db5?sid=612daefb-d3a7-4663-a2fe-284ccd9a270f",
        },
        {
          id: 3,
          title: "Updating Revenue Accounts for Products in QuickBooks",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/793492b8323b43c9b345c8e30c9af6c4-2e0d47bb0e0ee32b-full-play.gif",
          url: "https://www.loom.com/embed/793492b8323b43c9b345c8e30c9af6c4?sid=72dd8a42-2036-4f1f-9a94-46a37622ea37",
        },
        {
          id: 4,
          title: "Customizing Dashboard Views in HubSpot",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/4663bd46709d47488b684cf8401ca465-e132f9baf2ada03e-full-play.gif",
          url: "https://www.loom.com/embed/4663bd46709d47488b684cf8401ca465?sid=5af954c7-d933-4af2-81d4-971e3bb8c95c",
        }, 
        {
          id: 5,
          title: "Understanding Associations in HubSpot",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/bc3dc7531b494e60bc528a6b028d8d9f-69276ba2dab51e71-full-play.gif",
          url: "https://www.loom.com/embed/bc3dc7531b494e60bc528a6b028d8d9f?sid=ba11474b-a93a-4a25-a8cb-27cf23a7ac1f",
        }, 
        {
          id: 6,
          title: "HubSpot Workflow Automation Example",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/b97ec7176f164c7893eb5d86765e5e53-ef8ebbc880fe3036-full-play.gif",
          url: "https://www.loom.com/embed/b97ec7176f164c7893eb5d86765e5e53?sid=9b119bb7-c981-4f53-b913-cd7f657e090c",
        }, 
        {
          id: 7,
          title: "Bulk Upload New Customers into QuickBooks",
          thumbnail: "https://cdn.loom.com/sessions/thumbnails/b4b3fbe865034599a9d9524327d3986d-a533eaccb73926b5-full-play.gif",
          url: "https://www.loom.com/embed/b4b3fbe865034599a9d9524327d3986d?sid=cd444cfc-3e52-401f-93ec-2e83d2c98355",
        }, 
      ];

    return (
        <div>
            <div className="content-header">
                <h1>User Tutorials</h1>
                <p>Learn helpful tips to get the most of of Slipstream, HubSpot, and Quickbooks.</p>
                <hr />
            </div>

            <div className="tutorials-grid">
                {videos.map((video) => (
                    <div key={video.id} className="tutorial-card card">
                        <h3>{video.title}</h3>
                        <img src={video.thumbnail} alt={video.title} />
                        <button className="btn btn-secondary" style={{width: "100%"}} onClick={() => setSelectedVideo(video.id)}>Watch Video</button>
                    </div>
                ))}
            </div>
            
            {selectedVideo !== null && (
                <div className="video-modal">
                    <h3>{videos[selectedVideo].title}</h3>
                    <iframe src={videos[selectedVideo].url} title={videos[selectedVideo].title} />
                    <button className="btn btn-secondary" style={{width: "100%"}} onClick={() => setSelectedVideo(null)}>Close</button>
                </div>
            )}
        </div>
    );
};

export default Tutorials;